import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetOwnPasswordMutationVariables = Types.Exact<{
  input: Types.ResetOwnPasswordInput;
}>;


export type ResetOwnPasswordMutation = { __typename?: 'RootMutationType', resetOwnPassword: { __typename?: 'ResetPasswordResult', error?: string | null, success: boolean } };


export const ResetOwnPasswordDocument = gql`
    mutation resetOwnPassword($input: ResetOwnPasswordInput!) {
  resetOwnPassword(input: $input) {
    error
    success
  }
}
    `;
export type ResetOwnPasswordMutationFn = Apollo.MutationFunction<ResetOwnPasswordMutation, ResetOwnPasswordMutationVariables>;

/**
 * __useResetOwnPasswordMutation__
 *
 * To run a mutation, you first call `useResetOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOwnPasswordMutation, { data, loading, error }] = useResetOwnPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetOwnPasswordMutation, ResetOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetOwnPasswordMutation, ResetOwnPasswordMutationVariables>(ResetOwnPasswordDocument, options);
      }
export type ResetOwnPasswordMutationHookResult = ReturnType<typeof useResetOwnPasswordMutation>;
export type ResetOwnPasswordMutationResult = Apollo.MutationResult<ResetOwnPasswordMutation>;
export type ResetOwnPasswordMutationOptions = Apollo.BaseMutationOptions<ResetOwnPasswordMutation, ResetOwnPasswordMutationVariables>;